import { render, staticRenderFns } from "./left_3.vue?vue&type=template&id=0f606c33&scoped=true&"
import script from "./left_3.vue?vue&type=script&lang=js&"
export * from "./left_3.vue?vue&type=script&lang=js&"
import style0 from "./left_3.vue?vue&type=style&index=0&id=0f606c33&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f606c33",
  null
  
)

export default component.exports